import React, { createContext, useContext, useMemo, useState } from 'react';

const DICTIONARY = {
  en: {
    nav_home: 'Home',
    nav_browse: 'Browse',
    nav_orders: 'Orders',
    nav_cart: 'Cart',
    nav_profile: 'Profile',
    nav_admin: 'Admin',
    nav_restaurant: 'Restaurant',
    nav_driver: 'Driver',
    nav_order_now: 'Order Now',
    nav_partner: 'Become a partner',
    nav_login: 'Login',
    nav_register: 'Register',
    nav_logout: 'Logout',
    cart_title: 'Your Cart',
    cart_empty: 'Your cart is empty',
    cart_empty_sub: 'Add some delicious food from our restaurants.',
    cart_place_order: 'Place Order',
    tracking_title: 'Order Tracking',
    restaurants_title: 'Discover Kasi Eats',
    profile_title: 'Profile',
    language: 'Language',
  },
  af: {
    nav_home: 'Tuis',
    nav_browse: 'Verken',
    nav_orders: 'Bestellings',
    nav_cart: 'Mandjie',
    nav_profile: 'Profiel',
    nav_admin: 'Admin',
    nav_restaurant: 'Restaurant',
    nav_driver: 'Bestuurder',
    nav_order_now: 'Bestel nou',
    nav_partner: 'Word \'n vennoot',
    nav_login: 'Teken in',
    nav_register: 'Registreer',
    nav_logout: 'Teken uit',
    cart_title: 'Jou mandjie',
    cart_empty: 'Jou mandjie is leeg',
    cart_empty_sub: 'Voeg lekker kos van ons restaurante by.',
    cart_place_order: 'Plaas bestelling',
    tracking_title: 'Bestellingopsporing',
    restaurants_title: 'Ontdek Kasi Kos',
    profile_title: 'Profiel',
    language: 'Taal',
  },
  zu: {
    nav_home: 'Ikhaya',
    nav_browse: 'Bheka',
    nav_orders: 'Ama-oda',
    nav_cart: 'Inqola',
    nav_profile: 'Iphrofayela',
    nav_admin: 'Umphathi',
    nav_restaurant: 'Indawo yokudla',
    nav_driver: 'Umshayeli',
    nav_order_now: 'Oda manje',
    nav_partner: 'Yiba uzakwethu',
    nav_login: 'Ngena',
    nav_register: 'Bhalisa',
    nav_logout: 'Phuma',
    cart_title: 'Inqola yakho',
    cart_empty: 'Inqola yakho ayinalutho',
    cart_empty_sub: 'Engeza ukudla okumnandi ezitolo zethu.',
    cart_place_order: 'Faka i-oda',
    tracking_title: 'Ukulandelela i-oda',
    restaurants_title: 'Thola ukudla kweKasi',
    profile_title: 'Iphrofayela',
    language: 'Ulimi',
  },
};

const STORAGE_KEY = 'skhaftin_language';
const I18nContext = createContext(null);

const getInitialLanguage = () => {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored && DICTIONARY[stored]) return stored;
  const browserLang = (navigator.language || 'en').slice(0, 2).toLowerCase();
  return DICTIONARY[browserLang] ? browserLang : 'en';
};

export const I18nProvider = ({ children }) => {
  const [language, setLanguage] = useState(getInitialLanguage);

  const value = useMemo(() => {
    const t = (key, fallback = '') => DICTIONARY[language]?.[key] || DICTIONARY.en[key] || fallback || key;
    const changeLanguage = (lang) => {
      if (!DICTIONARY[lang]) return;
      localStorage.setItem(STORAGE_KEY, lang);
      setLanguage(lang);
    };
    return { language, t, changeLanguage, supportedLanguages: Object.keys(DICTIONARY) };
  }, [language]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error('useI18n must be used within I18nProvider');
  }
  return context;
};
